module.exports = __webpack_public_path__ + "media/images/logo-compleet-wit2-1a704722ae85a5c9dd55518f3c7319e3.svg";